import { intersection } from 'ramda';
/**
 * Check if user profile matches one in coma-separated profile list
 * @param {String} urlTemplates
 * @param {Array} userUrlTemplates
 * @returns {boolean}
 */
export const isProfileAllowed = (urlTemplates, userUrlTemplates = []) => {
    if (!urlTemplates || !userUrlTemplates.length) {
        return false;
    }

    const commonUrlTemplates = intersection(
        urlTemplates.split(',').map(template => template.trim()),
        userUrlTemplates.map(template => template.trim())
    );

    return Boolean(commonUrlTemplates.length);
};
